import {
  SecondaryText,
  SingleCardItem,
  SubTitle,
  Title,
} from "components/views/ui";

const CANDARW2025 = () => {
  return (
    <SingleCardItem>
      <Title
        title={
          "Proposal of Detection Method for Remaining Vulnerability for Software Development Environment"
        }
        hyperLink="https://ieeexplore.ieee.org/document/11318893"
      />
      <SubTitle
        title={
          "Thirteenth International Symposium on Computing and Networking Workshops (CANDARW) 2025"
        }
      />
      <SubTitle
        title={"Kazuki Oe, Hiroki Kuzuno, Keiichiro Kimura, Makoto Takita, and Yoshiaki Shiraishi"}
      />
      <SecondaryText text="Peer-Reviewed International Conference Paper" />
      <SecondaryText text="pp.267-273, 2025-11-25 to 28" />
    </SingleCardItem>
  );
};

export default CANDARW2025;
